import { Component } from '@angular/core';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastNotificationService } from '../../../core/toast-notification.service';
import { UIBlockingService } from '../../../core/ui-blocking.service';
import { MemberUserManagementService } from '../../member-user-management/member-user-management.service';
import { DumbCompanyAddress } from '../DTOs/dumb-company-address';
import { DumbLiaison } from '../DTOs/dumb-liaison';
import { MembershipManagementService } from '../membership-management.service';

@Component({
  selector: 'app-add-edit-address-modal',
  templateUrl: './add-edit-address-modal.component.html',
  providers: [UIBlockingService]
})
export class AddEditAddressModalComponent {
  address: DumbCompanyAddress;
  adding: boolean;
  headerText: string;

  constructor(private activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private membershipService: MembershipManagementService,
    private notificationService: ToastNotificationService,
    private blockUI: UIBlockingService) { }

  locationNameCtrl = new FormControl("locationName", [Validators.required]);
  emailAddressCtrl = new FormControl("emailAddress");
  phoneNumberCtrl = new FormControl("phoneNumber", [Validators.required]);
  notesCtrl = new FormControl("notes");
  streetCtrl = new FormControl("street", [Validators.required]);
  cityCtrl = new FormControl("city", [Validators.required]);
  zipCtrl = new FormControl("zip", [Validators.required]);

  manageLocationForm: FormGroup = new FormGroup({
    locationName: this.locationNameCtrl,
    emailAddress: this.emailAddressCtrl,
    phoneNumber: this.phoneNumberCtrl,
    notes: this.notesCtrl,
    street: this.streetCtrl,
    city: this.cityCtrl,
    zip: this.zipCtrl
  });

  locationName() { return this.manageLocationForm.get('locationName').value }
  emailAddress() { return this.manageLocationForm.get('emailAddress').value }
  phoneNumber() { return this.manageLocationForm.get('phoneNumber').value }
  notes() { return this.manageLocationForm.get('notes').value }
  street() { return this.manageLocationForm.get('street').value }
  city() { return this.manageLocationForm.get('city').value }
  zip() { return this.manageLocationForm.get('zip').value }

  ngOnInit() {
    this.resetmanageLocationForm();
  }

  private resetmanageLocationForm(): void {
    this.manageLocationForm.reset();
    this.manageLocationForm.patchValue({
      locationName: this.address.locationName,
      emailAddress: this.address.locationEmail,
      phoneNumber: this.address.locationPhone,
      notes: this.address.notes,
      street: this.address.street,
      city: this.address.city,
      zip: this.address.zip
    });
  }

  saveAddress() {

    for (var i in this.manageLocationForm.controls) {
      this.manageLocationForm.controls[i].markAsTouched();
    }
    if (!this.manageLocationForm.valid) {
      return false;
    }

    this.address.locationName = this.locationName();
    this.address.locationEmail = this.emailAddress();
    this.address.locationPhone = this.phoneNumber();
    this.address.notes = this.notes();
    this.address.street = this.street();
    this.address.city = this.city();
    this.address.zip = this.zip();

    var addressId = this.address.id;
    if (this.adding)
      addressId = null;

    this.blockUI.start();
    this.membershipService.AddUpdateCompanyAddress(this.address, this.adding)
      .subscribe({
        next: (data) => {
            this.blockUI.stop();
            this.activeModal.close(data);
        },
        error: (err) => {
          console.log(err)
          this.notificationService.error(err.error.message);
          this.blockUI.stop();
        },
      });

    return true;

  }

  dismiss(): void {
    this.activeModal.dismiss();
  }

}
